import { css } from '@eti/styles';
import { ContentWrapper, variants } from '@eti/components';
import { Button } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';

import { buttonStyles } from './YourSelectedTripPage';

const bottomContentWrapperStyles = css`
  display: flex;
  flex-direction: column;
  margin: 24px 0;

  > * {
    width: 100%;
  }
`;

const proceedButtonWrapperStyles = css`
  display: flex;
  justify-content: center;
`;

interface ProceedButtonProps {
  handleProceedButtonClick: (productIdsToPurchase: number[]) => void;
  selectedBundleId?: string;
  selectedExtraProducts: number[];
  shouldDisplayAncillaryBundle: boolean;
}

const ProceedButton = ({
  handleProceedButtonClick,
  selectedBundleId,
  selectedExtraProducts,
  shouldDisplayAncillaryBundle,
}: ProceedButtonProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const shouldUseValidation = p(
    'IbeClient.TravelerDetails.OptionalProductsRequireValidation.Enabled',
  );
  const continueButtonLabel = t('YourSelectedTrip.Page.ProceedButton.Label');

  return (
    <section className={bottomContentWrapperStyles} data-testid="continue-button-wrapper">
      <ContentWrapper className={proceedButtonWrapperStyles}>
        <Button
          className={buttonStyles}
          data-testid="yourSelectedTrip-proceedButton"
          isDisabled={
            shouldUseValidation ? shouldDisplayAncillaryBundle && !selectedBundleId : false
          }
          onClick={() => handleProceedButtonClick(selectedExtraProducts)}
          variant={variants.PRIMARY}
        >
          {continueButtonLabel}
        </Button>
      </ContentWrapper>
    </section>
  );
};

export default ProceedButton;
